"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _core = require("@material-ui/core");

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _enableFullscreen = _interopRequireDefault(require("./enableFullscreen"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _Select = _interopRequireDefault(require("./Select"));

var _Modal = _interopRequireDefault(require("../Modal/Modal"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _AppBar = _interopRequireDefault(require("../AppBar/AppBar"));

var _Divider = _interopRequireDefault(require("../Divider/Divider"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _Container = _interopRequireDefault(require("../Container/Container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  margin-left: 15px;\n  margin-right: 15px;\n\n  span.material-icons {\n    color: #6d6d6d;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * {\n    cursor: pointer;\n  }\n\n  span.material-icons {\n    color: #6d6d6d;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SourceTextFieldStyled = (0, _styledComponents.default)(_TextField.default)(_templateObject());
var TextFieldStyled = (0, _styledComponents.default)(_TextField.default)(_templateObject2());
var ToolbarStyled = (0, _styledComponents.default)(_Toolbar.default)(_templateObject3());
var GridCenterStyled = (0, _styledComponents.default)(_Grid.default)(_templateObject4());
var GridScrollStyled = (0, _styledComponents.default)(_Grid.default)(_templateObject5());
var AppBarStyled = (0, _styledComponents.default)(_AppBar.default)(_templateObject6());

var Transition = function Transition(props) {
  return _react.default.createElement(_Slide.default, Object.assign({
    direction: "up"
  }, props));
};

var SelectField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectField, _React$Component);

  function SelectField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false,
      filteredOptions: _this.props.options,
      value: _this.props.value
    };

    _this.getLabel = function () {
      var data = _this.props.options.find(function (o) {
        return o.id === _this.state.value;
      });

      return data && data.label || _this.state.value;
    };

    _this.filter = function (value) {
      var options = _this.props.options.filter(function (o) {
        return o.label.match(value);
      });

      _this.setState({
        filteredOptions: options,
        value: value
      });
    };

    _this.open = function () {
      if (!_this.props.disabled) _this.setState({
        open: true
      });
    };

    _this.close = function () {
      _this.setState({
        open: false
      });
    };

    _this.select = function (value) {
      _this.props.onChange({
        value: value,
        name: _this.props.name
      });

      _this.setState({
        value: value
      });

      if (_this.props.fullScreen) _this.close();
    };

    return _this;
  }

  _createClass(SelectField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          closeLabel = _this$props.closeLabel,
          fullScreen = _this$props.fullScreen,
          name = _this$props.name,
          options = _this$props.options,
          disabled = _this$props.disabled,
          props = _objectWithoutProperties(_this$props, ["label", "closeLabel", "fullScreen", "name", "options", "disabled"]);

      var _this$state = this.state,
          value = _this$state.value,
          open = _this$state.open,
          filteredOptions = _this$state.filteredOptions;
      return !fullScreen ? _react.default.createElement(_Select.default, Object.assign({}, props, {
        name: name,
        value: value,
        options: filteredOptions,
        onChange: function onChange(e) {
          return _this2.select(e.target.value);
        },
        label: label,
        disabled: disabled
      })) : _react.default.createElement("div", props, _react.default.createElement(SourceTextFieldStyled, {
        label: label,
        value: this.getLabel(),
        icon: "arrow_drop_down",
        readOnly: true,
        disabled: disabled,
        onClick: this.open,
        endAdornment: _react.default.createElement(_core.InputAdornment, {
          position: "end"
        }, _react.default.createElement(_Icon.default, {
          name: "arrow_drop_down"
        }))
      }), _react.default.createElement(_Modal.default, {
        fullScreen: true,
        open: open,
        TransitionComponent: Transition,
        onClose: function onClose() {
          return _this2.setState({
            open: !open
          });
        }
      }, _react.default.createElement(AppBarStyled, {
        position: "static"
      }, _react.default.createElement(ToolbarStyled, null, _react.default.createElement(_Grid.default, {
        container: true,
        alignItems: "center"
      }, _react.default.createElement(_Grid.default, {
        item: true,
        xs: 2
      }, _react.default.createElement(_IconButton.default, {
        color: "inherit",
        onClick: this.close
      }, _react.default.createElement(_Icon.default, {
        name: "keyboard_backspace"
      }))), _react.default.createElement(GridCenterStyled, {
        item: true,
        xs: 8
      }, _react.default.createElement(_Typography.default, {
        variant: "h6",
        color: "inherit"
      }, closeLabel)), _react.default.createElement(_Grid.default, {
        item: true,
        xs: 2
      })))), _react.default.createElement(_Grid.default, {
        container: true,
        direction: "column",
        wrap: "nowrap",
        component: _Container.default
      }, _react.default.createElement(TextFieldStyled, {
        label: label,
        value: this.getLabel(),
        icon: "arrow_drop_down",
        onChange: function onChange(e) {
          return _this2.filter(e.currentTarget.value);
        },
        focus: true,
        disabled: disabled,
        endAdornment: _react.default.createElement(_core.InputAdornment, {
          position: "end"
        }, _react.default.createElement(_Icon.default, {
          name: "arrow_drop_down"
        }))
      }), _react.default.createElement(GridScrollStyled, {
        item: true,
        component: _List.default
      }, _react.default.createElement(_Divider.default, null), filteredOptions.map(function (o) {
        return _react.default.createElement(_react.Fragment, {
          key: o.id
        }, _react.default.createElement(_ListItem.default, {
          button: true,
          onClick: function onClick() {
            return _this2.select(o.id);
          }
        }, o.id === value ? _react.default.createElement(_Icon.default, {
          name: "check"
        }) : _react.default.createElement(_Icon.default, {
          name: ""
        }), _react.default.createElement(_ListItemText.default, {
          primary: o.label
        })), _react.default.createElement(_Divider.default, null));
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.options !== state.filteredOptions) {
        return {
          filteredOptions: props.options
        };
      }

      return null;
    }
  }]);

  return SelectField;
}(_react.default.Component);

SelectField.defaultProps = {
  value: '',
  name: undefined,
  fullScreen: false,
  disabled: false,
  closeLabel: ''
};

var _default = (0, _enableFullscreen.default)(SelectField);

exports.default = _default;